// extracted by mini-css-extract-plugin
module.exports = {"mobilePaginationWrapper":"InactiveDrip_mobilePaginationWrapper__1MIrn","listWrap":"InactiveDrip_listWrap__3ospO"};